import { Controller } from "@hotwired/stimulus"

// One shared Step 1 modal. Row "View" loads ONE page JPEG — never the full PDF.
export default class extends Controller {
  static targets = ["dialog", "img", "heading", "sub"]
  static values = { previewUrl: String }

  connect() {
    this._placeholder =
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23070a0e' width='100' height='100'/%3E%3C/svg%3E"
    this._gen = 0
  }

  open(event) {
    event?.preventDefault?.()
    const btn = event?.currentTarget
    if (!btn) return
    const page = Number(btn.dataset.page || "0")
    if (!page || page < 1) return
    if (!this.previewUrlValue) return

    const number = (btn.dataset.number || "").trim()
    const name = (btn.dataset.name || "").trim()
    if (this.hasHeadingTarget) {
      this.headingTarget.textContent = number ? `${number} · page ${page}` : `Page ${page}`
    }
    if (this.hasSubTarget) {
      this.subTarget.textContent = name || "Page preview"
    }

    this._gen += 1
    const gen = this._gen
    const url = `${this.previewUrlValue}?page_number=${page}&max_edge=960`
    if (this.hasImgTarget) {
      this.imgTarget.src = this._placeholder
      requestAnimationFrame(() => {
        if (gen !== this._gen) return
        this.imgTarget.src = url
        this.imgTarget.alt = `Page ${page}`
      })
    }
    if (this.hasDialogTarget) {
      this.dialogTarget.hidden = false
      document.body.classList.add("cd-sheet-preview-open")
    }
  }

  close(event) {
    event?.preventDefault?.()
    this._gen += 1
    if (this.hasDialogTarget) this.dialogTarget.hidden = true
    if (this.hasImgTarget) this.imgTarget.src = this._placeholder
    document.body.classList.remove("cd-sheet-preview-open")
  }

  backdrop(event) {
    if (event?.target === event?.currentTarget) this.close(event)
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.hasDialogTarget && !this.dialogTarget.hidden) {
      this.close(event)
    }
  }
}
